.en{width:max-content;}